import React from 'react';
import './assets/css/styles.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Usa BrowserRouter como Router si prefieres usar BrowserRouter

import Wizard from './components/Wizard';
import QrScan from './components/QrScan';
import Logs from './components/Logs';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Wizard />} />
        <Route path="/qr/:id" element={<QrScan />} />
        <Route path="/logs" element={<Logs />} />
      </Routes>
    </Router>
  );
}

export default App;
